export const TAXONOMY_LEVEL_1 = [
  'footwear',
  'apparel',
  'accessories',
  'bags',
  'jewelry',
  'media',
  'objects',
  'home',
  'collectibles',
  'art',
  'other',
  'sports',
];

export const TAXONOMY_LEVEL_2 = [
  'sneakers',
  'boots',
  'cleats',
  'sandals',
  'tops',
  'bottoms',
  'outerwear',
  'dresses',
  'swimwear',
  'tailoring',
  'underwear and loungewear',
  'activewear',
  'sleepwear',
  'jumpsuits and overalls',
  'hats',
  'eyewear',
  'socks and tights',
  'wallets',
  'scarves',
  'belts',
  'technology',
  'gloves',
  'keychains and lanyards',
  'ties',
  'hair accessories',
  'travel',
  'masks',
  'water bottles',
  'umbrellas',
  'shoulder bags',
  'tote bags',
  'backpacks',
  'top handles',
  'pouches',
  'crossbody bags',
  'duffles',
  'clutches',
  'belt bags',
  'bucket bags',
  'necklaces',
  'bracelets',
  'rings',
  'earrings',
  'watches',
  'pins',
  'brooches',
  'fine jewelry',
  'music',
  'books',
  'magazines',
  'toys',
  'vases',
  'furniture',
  'cushions',
  'glassware',
  'incense',
  'rugs',
  'comics',
  'skate boards',
  'soccer balls',
  'prints',
  'photography',
  'ski',
  'skate',
  'racing',
  'soccer',
  'tennis',
  'basketball',
  'baseball',
  'espadrilles',
  'clogs',
  'heels',
  'slip-ons',
];

export const TAXONOMY_LEVEL_3 = [
  't-shirts',
  'hoodies',
  'shirts and tops',
  'sweatshirts',
  'knitwear',
  'pants',
  'shorts',
  'jeans',
  'sweatpants',
  'skirts',
  'trousers',
  'joggers',
  'jackets',
  'vests',
  'coats',
  'parkas',
  'anoraks',
  'capes and ponchos',
  'short dresses',
  'mid dresses',
  'long dresses',
  'swim shorts',
  'bikinis',
  'one piece',
  'blazers',
  'waistcoats',
  'sets',
  'underwear',
  'lingerie',
  'loungewear',
  'leggings',
  'sport bras',
  'sports tops',
  'caps',
  'beanies',
  'bucket hats',
  'balaclavas',
  'berets',
  'fedoras',
  'beach hats',
  'aviator hats',
  'western',
  'sunglasses',
  'glasses',
  'goggles',
  'cardholders',
  'bifolds',
  'coin pouches',
  'money clips',
  'neck scarves',
  'phone cases and holders',
  'earpod holder  s',
  'headphones',
  'phone accessories',
  'headbands',
  'hairbands',
  'chokers',
];

export const TAXONOMY_LEVEL_4 = [
  'short sleeve t-shirts',
  'long sleeve t-shirts',
  'zip ups',
  'button up shirts',
  'polos',
  'jerseys',
  'tanks',
  'flannels',
  'overshirts',
  'cropped tops',
  'bodysuits',
  'blouses',
  'crewnecks',
  'half zips',
  'sweaters',
  'cardigans',
  'turtlenecks',
  'track pants',
  'cargo pants',
  'leather pants',
  'cargo shorts',
  'track jackets',
  'bomber jackets',
  'denim jackets',
  'puffer jackets',
  'varsity jackets',
  'down jackets',
  'fleece jackets',
  'coach jackets',
  'leather jackets',
  'shearling jackets',
  'faux fur jackets',
  'trench coats',
  'overcoats',
  'peacoats',
  'bikini tops',
  'bikini bottoms',
  'snapbacks',
  'baseball caps',
  'truckers',
];

export const FOOTWEAR_ACTIVITIES = [
  'lifestyle',
  'running',
  'basketball',
  'other',
  'skateboarding',
  'cleat',
  'sandal',
  'boot',
  'shoes',
];
